module.exports = __webpack_public_path__ + "img/line.8a54c65d.svg";